import { render, staticRenderFns } from "./OperaGoodsInfoWindow.vue?vue&type=template&id=46a2c3b2&scoped=true&"
import script from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsInfoWindow.vue?vue&type=style&index=0&id=46a2c3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a2c3b2",
  null
  
)

export default component.exports